export default "__VITE_ASSET__EduOy2kW__"